export const INSTALLER_LIST = [
    {
        accountID: 2,
        skillSet: "SENIOR",
        hours: "40",
        profilePicture: "Chris.jpg",
    },
    {
        accountID: 9,
        skillSet: "INTERMEDIATE",
        hours: "32",
        profilePicture: "John.jpg",
    },
    {
        accountID: 10,
        skillSet: "JUNIOR",
        hours: "24",
        profilePicture: "Greg.jpg",

    },
    {
        accountID: 11,
        skillSet: "JUNIOR",
        hours: "24",
        profilePicture: "Fiona.jpg",
    },
    {
        accountID: 12,
        skillSet: "TRAINEE",
        hours: "10",
        profilePicture: "Nicole.jpg",
    },
]